import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "audio",
    "toggle",
    "playIcon",
    "pauseIcon",
    "scrubber",
    "currentTime",
    "totalTime",
    "caption",
  ];

  connect() {
    this.updateAvailability();
  }

  toggle() {
    if (!this.audioTarget.src) return;

    if (this.audioTarget.paused) {
      this.audioTarget.play();
    } else {
      this.audioTarget.pause();
    }
  }

  seek() {
    if (!this.audioTarget.duration) return;

    this.audioTarget.currentTime =
      (Number(this.scrubberTarget.value) / 100) * this.audioTarget.duration;
  }

  update() {
    if (!this.audioTarget.duration) return;

    this.scrubberTarget.value =
      (this.audioTarget.currentTime / this.audioTarget.duration) * 100;
    this.currentTimeTarget.textContent = this.formatTime(
      this.audioTarget.currentTime,
    );
  }

  metadataLoaded() {
    this.updateAvailability();
    this.totalTimeTarget.textContent = this.formatTime(this.audioTarget.duration);
  }

  setSource(src, caption = "") {
    this.audioTarget.src = src;
    if (this.hasCaptionTarget) {
      this.captionTarget.textContent = caption;
      this.captionTarget.classList.toggle("hidden", caption.length === 0);
    }
    this.audioTarget.load();
    this.updateAvailability();
  }

  updateAvailability() {
    const hasSource = Boolean(this.audioTarget.currentSrc || this.audioTarget.src);
    this.toggleTarget.disabled = !hasSource;
    this.scrubberTarget.disabled = !hasSource;

    this.audioTarget.onloadedmetadata = () => this.metadataLoaded();
    this.audioTarget.ontimeupdate = () => this.update();
    this.audioTarget.onplay = () => this.setPlaying(true);
    this.audioTarget.onpause = () => this.setPlaying(false);
    this.audioTarget.onended = () => this.setPlaying(false);
  }

  setPlaying(playing) {
    this.playIconTarget.classList.toggle("hidden", playing);
    this.pauseIconTarget.classList.toggle("hidden", !playing);
    this.toggleTarget.setAttribute(
      "aria-label",
      playing
        ? this.toggleTarget.dataset.pauseLabel || "Pause"
        : this.toggleTarget.dataset.playLabel || "Play",
    );
  }

  formatTime(seconds) {
    if (!Number.isFinite(seconds)) return "0:00";

    const total = Math.floor(seconds);
    const minutes = Math.floor(total / 60);
    const remainingSeconds = String(total % 60).padStart(2, "0");
    return `${minutes}:${remainingSeconds}`;
  }
}
